<script lang="ts">
  import { cn } from '@shared/utils';

  import { SelectionCard, type SelectionsReadManyResponse } from '@entities/selection';

  export let list: SelectionsReadManyResponse['selections'];
  export let classes = '';
</script>

<ul class="{cn('grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4', classes)}">
  {#each list as item}
    <li>
      <SelectionCard {item} />
    </li>
  {/each}
</ul>
